import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersSearchCurrentMailboxByDefault = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'default_current_mailbox_search', true)
)
